"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { isBefore, addDays, startOfDay } from "date-fns";
import classNames from "classnames";
import { useGeolocation } from "@travel/shared/hooks";
import { LocationSearchFeature } from "@travel/shared/locations/feature";
import { Button, DatePicker, } from "@travel/shared/ui";
import { HotelSearchGuestRoomsInput, validateHotelSearchGuestRooms, } from "@travel/hotel/search/ui";
import SearchIcon from "@travel/shared/assets/icons/icon-search.svg";
import styles from "./hotel-search-form.module.css";
var resolver = function (values) { return __awaiter(void 0, void 0, void 0, function () {
    var errors;
    return __generator(this, function (_a) {
        errors = {};
        if (!values.location) {
            errors.location = {
                type: "required",
                message: "Please enter your City, Airport, Point of Interest, or Hotel Name",
            };
        }
        if (!validateHotelSearchGuestRooms(values === null || values === void 0 ? void 0 : values.guestsAndRooms)) {
            errors.guestsAndRooms = {
                type: "required",
                message: "Please enter children's age to get the best price for your group",
            };
        }
        return [2 /*return*/, {
                values: !Object.keys(errors).length ? values : {},
                errors: errors,
            }];
    });
}); };
export function HotelSearchForm(_a) {
    var _b;
    var className = _a.className, locationProp = _a.location, _c = _a.location, location = _c === void 0 ? "" : _c, _d = _a.checkIn, checkIn = _d === void 0 ? new Date() : _d, _e = _a.checkOut, checkOut = _e === void 0 ? addDays(new Date(), 1) : _e, _f = _a.roomCount, roomCount = _f === void 0 ? 1 : _f, _g = _a.adultCount, adultCount = _g === void 0 ? 2 : _g, children = _a.children, _h = _a.horizontal, horizontal = _h === void 0 ? true : _h, _j = _a.display, display = _j === void 0 ? "full" : _j, _k = _a.searching, searching = _k === void 0 ? false : _k, loadingLocation = _a.loadingLocation, _l = _a.hideLocation, hideLocation = _l === void 0 ? false : _l, _m = _a.submitText, submitText = _m === void 0 ? "Search" : _m, recent = _a.recent, submitTheme = _a.submitTheme, onChange = _a.onChange, onLocationChange = _a.onLocationChange, onSubmit = _a.onSubmit;
    var _o = __read(useState(false), 2), isLocationFocused = _o[0], setIsLocationFocused = _o[1];
    var _p = useMemo(function () {
        var initialCheckIn = checkIn;
        var initialCheckOut = checkOut;
        if (isBefore(initialCheckIn, startOfDay(new Date()))) {
            initialCheckIn = startOfDay(new Date());
            initialCheckOut = addDays(new Date(), 1);
        }
        if (isBefore(startOfDay(initialCheckOut), initialCheckIn)) {
            initialCheckOut = addDays(initialCheckIn, 1);
        }
        return {
            initialCheckIn: initialCheckIn,
            initialCheckOut: initialCheckOut,
        };
    }, []), initialCheckIn = _p.initialCheckIn, initialCheckOut = _p.initialCheckOut;
    var _q = useForm({
        defaultValues: {
            location: locationProp,
            dates: {
                from: initialCheckIn,
                to: initialCheckOut,
            },
            guestsAndRooms: {
                roomCount: roomCount || 1,
                adultCount: adultCount || 2,
                children: children || [],
            },
        },
        resolver: resolver,
    }), control = _q.control, handleSubmit = _q.handleSubmit, setValue = _q.setValue, getValues = _q.getValues, errors = _q.formState.errors, watch = _q.watch;
    var _r = __read(useGeolocation(), 2), geolocation = _r[0], getCurrentPosition = _r[1];
    var datesRef = useRef(null);
    var roomsGuestsRef = useRef(null);
    var updateState = function (key, value) { };
    var handleChange = function (_a) {
        var currentTarget = _a.currentTarget;
        return updateState(currentTarget.name, currentTarget.value);
    };
    useEffect(function () {
        if (locationProp) {
            var currentLocation = getValues("location");
            var locationID = typeof locationProp === "object" ? locationProp.id : locationProp;
            if ((currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.id) !== locationID) {
                setValue("location", locationProp);
            }
        }
    }, [locationProp, getValues]);
    useEffect(function () {
        var subscription = watch(function (_a, k) {
            var location = _a.location, dates = _a.dates, guestsAndRooms = _a.guestsAndRooms;
            onChange === null || onChange === void 0 ? void 0 : onChange({
                location: location,
                checkIn: dates === null || dates === void 0 ? void 0 : dates.from,
                checkOut: dates === null || dates === void 0 ? void 0 : dates.to,
                roomCount: guestsAndRooms === null || guestsAndRooms === void 0 ? void 0 : guestsAndRooms.roomCount,
                adultCount: guestsAndRooms === null || guestsAndRooms === void 0 ? void 0 : guestsAndRooms.adultCount,
                children: guestsAndRooms === null || guestsAndRooms === void 0 ? void 0 : guestsAndRooms.children,
            });
        });
        return function () { return subscription.unsubscribe(); };
    }, [watch]);
    return (_jsxs("form", { className: classNames(styles["container"], className, styles[display], (_b = {},
            _b[styles["horizontal"]] = horizontal,
            _b[styles["vertical"]] = !horizontal,
            _b[styles["hide-location"]] = hideLocation,
            _b)), onSubmit: handleSubmit(submit), children: [!hideLocation && (_jsx(Controller, { control: control, name: "location", render: function (_a) {
                    var _b;
                    var _c = _a.field, onChange = _c.onChange, onBlur = _c.onBlur, value = _c.value, name = _c.name, ref = _c.ref, _d = _a.fieldState, invalid = _d.invalid, isTouched = _d.isTouched, isDirty = _d.isDirty, error = _d.error, formState = _a.formState;
                    return (_jsx(LocationSearchFeature, { className: styles["location"], name: "location", 
                        //query={value?.displayName}
                        value: value === null || value === void 0 ? void 0 : value.displayName, selected: value, recent: recent, error: (_b = errors.location) === null || _b === void 0 ? void 0 : _b.message, label: "Where", minWidth: "350px", loading: loadingLocation, onBlur: onBlur, onClickItem: handleLocationChange, onSelect: function (location) {
                            var _a;
                            onLocationChange === null || onLocationChange === void 0 ? void 0 : onLocationChange(location);
                            onChange(location ? location : null);
                            if (isLocationFocused && location) {
                                (_a = datesRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                            }
                        }, onFocusChange: setIsLocationFocused }));
                } })), _jsx(Controller, { control: control, name: "dates", render: function (_a) {
                    var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, name = _b.name, ref = _b.ref, _c = _a.fieldState, invalid = _c.invalid, isTouched = _c.isTouched, isDirty = _c.isDirty, error = _c.error, formState = _a.formState;
                    return (_jsx(DatePicker, { className: styles["dates"], name: name, mode: "range", value: value, min: 2, label: "Check in / Check out", 
                        //icon={<CalendarIcon />}
                        onChange: onChange, onBlur: onBlur, onBlured: function () {
                            if (value.from && !value.to) {
                                setValue("dates", {
                                    from: value.from,
                                    to: addDays(value.from, 1),
                                });
                            }
                        }, ref: datesRef }));
                } }), _jsx(Controller, { control: control, name: "guestsAndRooms", render: function (_a) {
                    var _b;
                    var _c = _a.field, onChange = _c.onChange, onBlur = _c.onBlur, value = _c.value, name = _c.name, ref = _c.ref, _d = _a.fieldState, invalid = _d.invalid, isTouched = _d.isTouched, isDirty = _d.isDirty, error = _d.error, formState = _a.formState;
                    return (_jsx(HotelSearchGuestRoomsInput, { name: name, value: value, error: (_b = errors === null || errors === void 0 ? void 0 : errors.guestsAndRooms) === null || _b === void 0 ? void 0 : _b.message, label: "Rooms & Guests", 
                        //icon={<PersonIcon />}
                        contentMinWidth: "400px", onBlur: onBlur, onChange: onChange, ref: roomsGuestsRef }));
                } }), _jsx(Button, { type: "submit", className: styles["submit"], size: "lg", disabled: loadingLocation, icon: _jsx(SearchIcon, {}), theme: submitTheme, loading: searching || geolocation.isLoading, children: submitText })] }));
    function submit(data) {
        return __awaiter(this, void 0, void 0, function () {
            var coords;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(data.location.type === "geo")) return [3 /*break*/, 2];
                        return [4 /*yield*/, getCurrentPosition()];
                    case 1:
                        coords = (_a.sent()).coords;
                        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(__assign(__assign({}, data), { location: __assign(__assign({}, data.location), { coords: coords }) }));
                        return [3 /*break*/, 3];
                    case 2:
                        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(data);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function handleLocationChange() {
        var _a;
        (_a = datesRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
}
export default HotelSearchForm;
